import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAdminTeamMemberById } from '../../../shared/api/team.services';

export const useFetchTeam = (memberId) => {
    const [member, setMember] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const [searchParams] = useSearchParams();
    const isCreateMode = memberId === 'create';

    const queryParams = useMemo(() => {
        const paramsObj = {};
        for (const [key, value] of searchParams.entries()) {
            paramsObj[key] = value;
        }
        return paramsObj;
    }, [searchParams]);

    useEffect(() => {
        if (isCreateMode || !memberId) {
            setMember(null);
            return;
        }

        const fetchMember = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const data = await getAdminTeamMemberById(memberId, queryParams);


                if (data && (data.item || Object.keys(data).length > 0)) {
                    const memberData = data.item || data;
                    setMember(memberData);
                } else {
                    console.error('Дані не знайдені або порожні:', data);
                    setError('Учасника не знайдено');
                }
            } catch (err) {
                console.error('Помилка при завантаженні учасника:', err);
                setError(err.message || 'Сталася помилка при завантаженні даних');
            } finally {
                setIsLoading(false);
            }
        };

        fetchMember();
    }, [memberId, isCreateMode, queryParams]);

    return { member, isLoading, error, isCreateMode };
};
